<template>

    <v-tooltip top open-delay="250" color="primary">
        <template v-slot:activator="{ on }">

            <div v-on="on"
                 :style="'border-left: 5px solid ' +  responseRateColor"
                 class="display-1 pl-2">
                <span v-if="project.response_rate < 3">
                    {{ roundValue(project.response_rate, 1) }}<span class="text-h5">%</span>
                </span>
                <span v-else>
                    {{ Math.round(project.response_rate) }}<span class="text-h5">%</span>
                </span>

            </div>
        </template>
        <div>

            <div v-if="project.invited_count > 0">
                Invitations: {{ project.invited_count }}
            </div>

            <div v-if="project.reminded_count > 0">
                Reminders: {{ project.reminded_count }}
            </div>

            <div v-if="project.started_count > 0">
                Started: {{ project.started_count }}
            </div>

            <div v-if="project.profile_count > 0">
                Profile: {{ project.profile_count }}
            </div>

            <div v-if="project.quota_count > 0">
                Quota: {{ project.quota_count }}
            </div>

            <div v-if="project.quality_count > 0">
                Quality: {{ project.quality_count }}
            </div>

            <div v-if="project.duplicate_count > 0">
                Duplicate: {{ project.duplicate_count }}
            </div>

            <div v-if="project.security_count > 0">
                Security: {{ project.security_count }}
            </div>

            <div v-if="project.completed_count > 0">
                Completes: {{ project.completed_count }}
            </div>

            <div v-if="project.routed_in_count > 0">
                Routed in: {{ project.routed_in_count }}
            </div>

            <div v-if="project.routed_in_count > 0">
                Routed out: {{ project.routed_out_count }}
            </div>

        </div>
    </v-tooltip>
</template>

<script>

import Json from 'vue-json-pretty';
import {rateColorMixin} from "../../../components/mixins/rateColorMixin";
import {colorTools} from "../../../components/mixins/colorTools";
import {numberDisplay} from "../../../components/mixins/numberDisplayMixin";

export default {

    mixins: [rateColorMixin, colorTools, numberDisplay],

    components: {
        Json
    },

    props: {
        project: {
            type: Object,
            required: true
        },
    },

    computed: {
        responseRateColor() {
            const color = this.calculateResponseRateColor(this.project.response_rate);
            return color ? this.convertToRgba(color, 0.7) : 'transparent';
        },
    },
}
</script>
